<template>
  <div>
    <div v-if="centerDialogVisible" class="tankex">
      <img
        class="xiugaizl"
        @click="guanBi"
        src="../assets/imgs/guanbigr.png"
        alt=""
      />
      <div class="gerenzx"><p>个人中心</p></div>
      <div style="margin-top: 10px" class="gerenBox">
        <div class="souyoufd" @click="tongBunc">
          <img class="tupiany" src="../assets/imgs/tongbunc.png" alt="" />
          <p class="tongbunc">同步昵称</p>
        </div>
        <div class="souyoufd" @click="getCouponInfo">
          <img class="tupiany" src="../assets/imgs/couponIcon.png" alt="" />
          <p class="tongbunc">&nbsp;优惠券</p>
        </div>
        <div class="souyoufd" @click="woDdindan">
          <img class="tupiany" src="../assets/imgs/wdddgr.png" alt="" />
          <p class="tongbunc">我的订单</p>
        </div>
        <div class="souyoufd" @click="getOnlineInfo">
          <img class="tupiany" src="../assets/imgs/wxscgr.png" alt="" />
          <p class="tongbunc">网校商城</p>
        </div>
        <div class="souyoufd" @click="yanzhengmal">
          <img class="tupiany" src="../assets/imgs/shxxgr.png" alt="" />
          <p class="tongbunc">商户信息</p>
        </div>
        <div class="souyoufd" @click="tousuJy">
          <img class="tupiany" src="../assets/imgs/tsjygr.png" alt="" />
          <p class="tongbunc">投诉建议</p>
        </div>
        <div class="souyoufd" @click="dialogVisiblemzsm = true">
          <img class="tupiany" src="../assets/imgs/mzsmgr.png" alt="" />
          <p class="tongbunc">免责申明</p>
        </div>
      </div>
    </div>
    <!-- 我的订单 -->
    <div class="woDdalist">
      <el-dialog
        :visible.sync="dialogVisible"
        width="814px"
        height=""
        :show-close="false"
        :lock-scroll="false"
      >
        <img
          class="xiugaizl"
          style="margin-left: 786px"
          @click="dialogVisible = false"
          src="../assets/imgs/guanbigr.png"
          alt=""
        />
        <p class="dingDan">我的订单</p>
        <el-table
          :data="tableData"
          :header-cell-style="{ background: '#f1f2f7', color: '#666666' }"
          style="width: 766px; margin-left: 24px; margin-top: 20px"
          height="335"
        >
          <el-table-column
            prop="goods_name"
            label="商品名称"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="price"
            label="商品售价"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="preferential_price"
            label="优惠金额"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="paid_amount"
            label="实付价格"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="ds_name"
            label="下单直播间"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="order_no"
            label="订单号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="submit_time"
            label="下单时间"
            width="100px"
            align="center"
          ></el-table-column>
        </el-table>
        <el-pagination
          class="fanYi"
          :current-page="page"
          :page-size="5"
          @current-change="handleCurrentChange"
          background
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </el-dialog>
    </div>
    <!-- 商户信息 -->
    <div class="woDdalistyi">
      <el-dialog
        :visible.sync="dialogVisiblesh"
        width="300px"
        :show-close="false"
        :lock-scroll="false"
      >
        <img
          class="xiugaizl"
          style="margin-left: 264px"
          @click="dialogVisiblesh = false"
          src="../assets/imgs/guanbigr.png"
          alt=""
        />
        <p class="anquanrz">安全验证</p>
        <div class="yanzhengm">
          <VerifyStyle :identifyCode="identifyCode"></VerifyStyle>
        </div>
        <p class="kanbuqi" @click="refreshCode()">看不清？点击刷新</p>
        <input
          v-model="inputCode"
          class="shuruyz"
          type="text"
          placeholder="输入图中字符"
        />
        <div class="tijiaoyz" @click="getSubmitData()">提交</div>
      </el-dialog>
    </div>
    <!-- 查看资质弹框 -->
    <div class="woDdalister">
      <el-dialog
        :close-on-press-escape="false"
        :visible.sync="dialogVisiblelist"
        width="462px"
        :show-close="false"
        :lock-scroll="false"
        center
      >
        <div>
          <img
            class="xiugaizl"
            style="margin-left: 434px"
            @click="dialogVisiblelist = false"
            src="../assets/imgs/guanbigr.png"
            alt=""
          />
          <p class="gsxxzz">公司信息</p>
          <div style="display: flex; margin-left: 24px; margin-top: 30px">
            <p class="qiyemc">企业名称</p>
            <p class="gongming">{{ org_name }}</p>
          </div>
          <div
            style="
              margin-left: 24px;
              display: flex;
              margin-left: 24px;
              margin-top: 30px;
            "
          >
            <p class="qiyemc">营业执照</p>
            <div class="demo-image__preview" style="margin-left: 20px">
              <img
                @click="tupianchakan = true"
                style="width: 160px; height: 213px"
                :src="business_img"
                alt=""
              />
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 展示营业执照 -->
    <el-dialog
      :close-on-press-escape="false"
      :visible.sync="tupianchakan"
      width="800px"
    >
      <div style="text-align: center">
        <img width="700px" :src="business_img" alt="" />
      </div>
    </el-dialog>
    <!-- 免责声明 -->
    <div class="woDdalistsan">
      <el-dialog
        :close-on-press-escape="false"
        :visible.sync="dialogVisiblemzsm"
        :lock-scroll="false"
        width="448px"
        :show-close="false"
        center
      >
        <img
          class="xiugaizl"
          style="margin-left: 420px"
          @click="dialogVisiblemzsm = false"
          src="../assets/imgs/guanbigr.png"
          alt=""
        />
        <div class="mianzed"><p>免责声明</p></div>
        <div class="shenmwz">
          尊敬的用户：<br />
          感谢您选择使用珊瑚课堂。在您开始使用前，请仔细阅读本免责声明，以确保您了解并同意其中的条款。<br />
          一、技术限制与风险<br />
          由于网络传输、设备性能等客观因素的影响，直播课可能会出现网络延迟、画面卡顿、声音失真等技术问题。我们会尽力提供稳定的直播服务，但对此类技术问题导致的观看体验不佳，我们不承担责任。<br />
          二、课程内容与讲师<br />
          1.直播课的内容由讲师提供并负责，我们仅提供技术平台。因此，对于课程内容的真实性、准确性、完整性以及适用性，我们不承担任何责任。<br />
          2.用户应自行判断课程内容是否适合自己的学习需求，并承担因选择不当而产生的任何后果。<br />
          三、用户行为与责任<br />
          1.用户在使用直播课服务时，应遵守相关的法律法规和道德准则，不得发布、传播违法、违规或不良信息。<br />
          2.用户应尊重讲师和其他用户的权益，不得进行侮辱、诽谤、骚扰等不当行为。<br />
          3.用户因个人操作不当或设备故障导致的任何问题，我们不承担责任。<br />
          四、服务中断与变更<br />
          因不可抗力因素（如自然灾害、政策调整等）导致直播课服务中断或变更，我们将尽力提前通知用户，但对此类情况造成的不便或损失，我们不承担责任。<br />
          五、争议解决<br />
          对于因使用直播课服务产生的任何争议，双方应首先通过友好协商解决；协商不成的，任何一方均有权向有管辖权的人民法院提起诉讼。<br />
          请您在使用直播课服务前，仔细阅读并理解本免责声明。如您不同意本声明的任何条款，请立即停止使用。感谢您的理解与配合。<br />
        </div>
        <div class="woyizx" @click="dialogVisiblemzsm = false">我已知悉</div>
      </el-dialog>
    </div>
    <!-- 投诉建议 -->
    <div class="woDdalistjianyi">
      <el-dialog
        :close-on-press-escape="false"
        :visible.sync="dialogVisiblejy"
        width="561px"
        :show-close="false"
        :lock-scroll="false"
        center
      >
        <img
          class="xiugaizl"
          style="margin-left: 523px"
          @click="dialogVisiblejy = false"
          src="../assets/imgs/guanbigr.png"
          alt=""
        />
        <div class="mianzeds"><p>投诉建议</p></div>
        <div style="padding: 0 24px; margin-top: 8px">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="我要投诉" name="first">
              <div style="padding-bottom: 20px">
                <div class="tousulx" style="margin-top: 10px">
                  <span style="color: #ff5227">*</span
                  ><span style="margin-left: 2px">投诉类型</span>
                </div>
                <div style="margin-top: 18px">
                  <div>
                    <el-radio v-model="radiots" :label="1">不实信息</el-radio>
                    <el-radio
                      style="margin-left: 30px"
                      v-model="radiots"
                      :label="2"
                      >退款问题</el-radio
                    >
                    <el-radio
                      style="margin-left: 30px"
                      v-model="radiots"
                      :label="3"
                      >侮辱谩骂</el-radio
                    >
                    <el-radio
                      style="margin-left: 30px"
                      v-model="radiots"
                      :label="4"
                      >存在侵权行为</el-radio
                    >
                  </div>
                  <div style="margin-top: 20px">
                    <el-radio v-model="radiots" :label="5"
                      >发布不适当内容对我造成骚扰</el-radio
                    >
                    <el-radio
                      style="margin-left: 30px"
                      v-model="radiots"
                      :label="6"
                      >以上没有我想举报的类型</el-radio
                    >
                  </div>
                </div>
                <div class="tousulx">
                  <span style="color: #ff5227">*</span
                  ><span style="margin-left: 2px">详细描述</span>
                </div>
                <div style="margin-top: 16px">
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    placeholder="请输入内容"
                    v-model="textarea2"
                    class="hide-scrollbar"
                  >
                  </el-input>
                </div>
                <div class="tousulx"><span>添加图片</span></div>
                <div class="tupianfa">
                  <div v-for="(item, index) in shangchuant" :key="index">
                    <img
                      class="xiugaizlyi"
                      @click="shanchuT(index)"
                      src="../assets/imgs/guanbigr.png"
                      alt=""
                    />
                    <img class="tupianxh" :src="item" alt="" />
                  </div>
                  <el-upload
                    style="float: left; margin-top: 5px"
                    action="#"
                    list-type="picture-card"
                    :on-remove="handleRemove"
                    :before-upload="imgList"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>
                <div style="clear: both"></div>
                <div class="tousulx">
                  <span style="color: #ff5227">*</span
                  ><span style="margin-left: 2px">联系电话</span>
                </div>
                <div style="margin-top: 16px; padding-bottom: 20px">
                  <el-input
                    v-model="phone"
                    placeholder="请输入手机号码"
                  ></el-input>
                </div>
                <span
                  style="margin-left: 370px"
                  slot="footer"
                  class="dialog-footer"
                >
                  <el-button class="quxiaots" @click="dialogVisiblejy = false"
                    >取 消</el-button
                  >
                  <el-button class="quedingts" type="primary" @click="appeal()"
                    >确 定</el-button
                  >
                </span>
              </div>
            </el-tab-pane>
            <el-tab-pane label="历史进度" name="second">
              <div class="tousudahz">
                <div
                  class="lishijindu"
                  v-for="(item, index) in applist"
                  :key="index"
                >
                  <div class="suoyouts">
                    <div style="float: left">
                      <span class="tousulist">投诉类型</span>
                      <span v-if="item.type === 1" class="yishangmy"
                        >不实信息</span
                      >
                      <span v-if="item.type === 2" class="yishangmy"
                        >退款问题</span
                      >
                      <span v-if="item.type === 3" class="yishangmy"
                        >侮辱谩骂</span
                      >
                      <span v-if="item.type === 4" class="yishangmy"
                        >存在侵权行为</span
                      >
                      <span v-if="item.type === 5" class="yishangmy"
                        >发布不适当内容对我造成骚扰</span
                      >
                      <span v-if="item.type === 6" class="yishangmy"
                        >以上没有我想举报的类型</span
                      >
                    </div>
                    <div
                      v-if="item.qiangqing != true"
                      style="float: right"
                      @click="chakanXq(item)"
                    >
                      <span class="chakantxxq">查看详情</span>
                      <i style="color: #1872ed" class="el-icon-arrow-down"></i>
                    </div>
                    <div
                      v-if="item.qiangqing == true"
                      style="float: right"
                      @click="chakanXqsq(item)"
                    >
                      <span class="chakantxxq">收起</span>
                      <i style="color: #1872ed" class="el-icon-arrow-up"></i>
                    </div>
                    <div
                      v-if="item.status === 1"
                      style="float: right; margin-right: 16px; color: #666666"
                      @click="chexiaots(item)"
                    >
                      撤销投诉
                    </div>
                  </div>
                  <div style="clear: both"></div>
                  <!-- <div v-if="item.qiangqing" class="suoyouts"><div><span class="tousulist">详细描述</span><span class="yishangmy">{{item.content}}</span></div></div> -->
                  <div class="suoyouts">
                    <div>
                      <span class="tousulist">提交时间</span
                      ><span class="yishangmy" style="margin-left: 24px">{{
                        item.create_time
                      }}</span>
                    </div>
                  </div>
                  <div class="suoyouts">
                    <div>
                      <span class="tousulist">投诉状态</span>
                      <span
                        v-if="item.status === 1"
                        class="yishangmy"
                        style="color: #ff9a40"
                        >受理核实中</span
                      >
                      <span
                        v-if="item.status === 2"
                        class="yishangmy"
                        style="color: #2cc797"
                        >已处理完成</span
                      >
                      <span
                        v-if="item.status === 3"
                        class="yishangmy"
                        style="color: red"
                        >撤销投诉</span
                      >
                    </div>
                  </div>
                  <div
                    v-if="item.qiangqing"
                    class="jindutiao"
                    style="height: 240px; margin-top: 16px"
                  >
                    <el-steps direction="vertical" :active="item.active">
                      <el-step>
                        <template slot="description">
                          <div style="margin-left: 13px">
                            {{ item.create_timefq }}
                          </div>
                          <div style="margin-left: 13px">发起投诉</div>
                          <div style="margin-left: 13px">
                            将尽快安排处理，给您带来不便，深表歉意
                          </div>
                        </template>
                      </el-step>
                      <el-step>
                        <template slot="description">
                          <div style="margin-left: 13px">
                            {{ item.create_timefq }}
                          </div>
                          <div style="margin-left: 13px">平台核实中</div>
                          <div style="margin-left: 13px">
                            您反映的正在核实查证中，请耐心等待。请不要重复投诉，感谢您的理解！
                          </div>
                        </template>
                      </el-step>
                      <el-step>
                        <template slot="description">
                          <div
                            style="margin-left: 13px"
                            v-if="item.statusyi === 2 || item.active === 2"
                          >
                            <div>{{ item.create_timejs }}</div>
                            <div>处理完成，机构留言：{{ item.result }}</div>
                            <div>已处理</div>
                          </div>
                          <div
                            style="margin-left: 13px"
                            v-if="item.statusyi === 3"
                          >
                            <div>{{ item.create_timejs }}</div>
                            <p style="color: red">撤销投诉</p>
                          </div>
                        </template>
                      </el-step>
                    </el-steps>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-dialog>
    </div>
    <div class="woDdalistsan">
      <el-dialog
        :close-on-press-escape="false"
        :visible.sync="dialogVisibleewm"
        width="448px"
        :show-close="false"
        center
      >
        <img
          class="xiugaizl"
          style="margin-left: 420px"
          @click="dialogVisibleewm = false"
          src="../assets/imgs/guanbigr.png"
          alt=""
        />
        <div id="qrCode_saoma"></div>
      </el-dialog>
    </div>
    <div class="woDdalistcxts">
      <el-dialog
        :close-on-press-escape="false"
        :visible.sync="dialogVisiblecxts"
        width="360px"
        style="margin-top: 232px"
        :show-close="false"
        center
      >
        <img
          class="xiugaizl"
          style="margin-left: 334px"
          @click="dialogVisiblecxts = false"
          src="../assets/imgs/guanbigr.png"
          alt=""
        />
        <div class="tousutsdhz">
          <img
            style="width: 18px; height: 18px"
            src="../assets/imgs/tishituts.png"
            alt=""
          />
          <span class="tousutsls">提示</span>
        </div>
        <p class="tousucx">确定撤销本条投诉吗？撤销后不可恢复</p>
        <div style="margin-left: 192px; margin-top: 20px">
          <el-button
            class="tousuqxan"
            type="primary"
            @click="dialogVisiblecxts = false"
            >取 消</el-button
          >
          <el-button class="tousuqdan" type="primary" @click="cancelAppeal"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <couponForm
      ref="couponForm"
      :dialogVisible="isCouponForm"
      :fans_id="fans_id"
      :channel_id="channel_id"
      @showGoodsQrCode="showGoodsQrCode"
      @close="close"
    />
  </div>
</template>
<script>
import tool from "@/kits/Tools.js";
import qs from "qs";
import VerifyStyle from "./VerifyStylegr.vue";
import COS from "cos-js-sdk-v5";
import couponForm from "./couponsComponents/couponForm.vue";

export default {
  props: ["uid", "ds_id", "appid", "fans_id", "channel_id"],
  components: {
    VerifyStyle,
    couponForm,
  },
  data() {
    return {
      dialogVisible: false,
      centerDialogVisible: false,
      tableData: [],
      page: 1,
      total: 0,
      dialogVisiblesh: false,
      identifyCodeType: "1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZ", // 定义验证类型 1.数字 2.字母
      identifyCode: "",
      inputCode: "", // text框输入的验证码
      dialogVisiblelist: false,
      business_img: "",
      org_name: "",
      tupianchakan: false,
      dialogVisiblemzsm: false,
      dialogVisiblejy: false,
      activeName: "first",
      radiots: 1,
      textarea2: "",
      dialogImageUrl: "",
      fileList2: [],
      cos: null,
      miniConfigData: {},
      occupyImg: "",
      shangchuant: [],
      phone: "",
      applist: [],
      active: 2,
      dialogVisibleewm: false,
      dialogVisiblecxts: false,
      id: "",
      isCouponForm: false,
    };
  },
  mounted() {
    this.initCos();
  },
  methods: {
    showGoodsQrCode(id) {
      this.$emit("showGoodsQrCode", id);
    },
    getCouponInfo() {
      this.isCouponForm = true;
      this.$refs.couponForm.initData("0");
    },
    close() {
      this.isCouponForm = false;
    },
    chexiaots(item) {
      this.dialogVisiblecxts = true;
      this.id = item.id;
    },
    cancelAppeal() {
      // 撤销投诉

      const data = {
        id: this.id,
      };
      this.axios
        .post(tool.baseUrlSchool() + "/appeal/cancelAppeal", qs.stringify(data))
        .then((res) => {
          // eslint-disable-next-line eqeqeq
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "撤销投诉成功!",
            });
            this.appealList();
            this.dialogVisiblecxts = false;
          }
        });
    },
    chakanXqsq(item) {
      this.$set(item, "qiangqing", false);
    },
    chakanXq(item) {
      // 查看详情
      const data = {
        id: item.id,
      };
      this.axios
        .post(tool.baseUrlSchool() + "/appeal/appealDegree", qs.stringify(data))
        .then((res) => {
          // eslint-disable-next-line eqeqeq
          if (res.data.code == 200) {
            this.$set(item, "qiangqing", true);
            if (res.data.data.length === 1) {
              this.$set(item, "active", 2);
              // this.active = 2
              this.$set(item, "create_timefq", res.data.data[0].create_time);
            } else if (res.data.data.length === 2) {
              // this.status = res.data.data[1].status
              this.$set(item, "statusyi", res.data.data[1].status);
              this.$set(item, "create_timefq", res.data.data[0].create_time);
              this.$set(item, "create_timejs", res.data.data[1].create_time);
              // this.create_time = res.data.data[0].create_time
              // this.create_timeyi = res.data.data[1].create_time
              this.$set(item, "result", res.data.data[1].result);
              if (
                res.data.data[1].status === 3 ||
                res.data.data[1].status === 2
              ) {
                // this.active = 3
                this.$set(item, "active", 3);
              }
            }
          }
        });
    },
    appealList() {
      // 投诉列表
      const data = {};
      this.axios
        .post(tool.baseUrlSchool() + "/appeal/appealList", qs.stringify(data))
        .then((res) => {
          // eslint-disable-next-line eqeqeq
          if (res.data.code == 200) {
            this.applist = res.data.data;
          }
        });
    },
    appeal() {
      // 提交投诉
      // eslint-disable-next-line eqeqeq
      if (this.textarea2 == "") {
        this.$message.error("请输入详细描述");
        return;
      }
      // eslint-disable-next-line eqeqeq
      if (this.phone == "") {
        this.$message.error("请输入手机号");
      }
      const data = {
        type: this.radiots,
        content: this.textarea2,
        contact: this.phone,
        evidence: JSON.stringify(this.shangchuant), // JSON.stringify()
      };
      this.axios
        .post(tool.baseUrlSchool() + "/appeal/appeal", qs.stringify(data))
        .then((res) => {
          // eslint-disable-next-line eqeqeq
          if (res.data.code == 200) {
            this.$message({
              message: res.data.data,
              type: "success",
            });
            this.textarea2 = "";
            this.phone = "";
            this.shangchuant = "";
          }
        });
    },
    shanchuT(index) {
      // 删除图片
      this.shangchuant.splice(index, 1);
    },
    initCos() {
      let that = this;
      this.cos = new COS({
        getAuthorization: function (options, callback) {
          // const url = process.env.VUE_APP_API_ONLINE_SCHOOL + '/common/index/getCosSign'
          // 'https://online.shkt.online/onlineapi'
          const url = tool.baseUrlSchool() + "/common/index/getCosSign";
          console.log(url, "url");
          // return
          const xhr = new XMLHttpRequest();
          xhr.open("GET", url, true);
          xhr.onload = function () {
            try {
              var data = JSON.parse(xhr.responseText);
              var credentials = data.data.credentials;
            } catch (e) {
              console.log(e);
            }
            if (!data || !credentials) {
              return console.error(
                "credentials invalid:\n" + JSON.stringify(data, null, 2)
              );
            }
            callback({
              TmpSecretId: credentials.tmpSecretId,
              TmpSecretKey: credentials.tmpSecretKey,
              SecurityToken: credentials.sessionToken,
              StartTime: data.data.startTime, // 时间戳，单位秒，如：1580000000
              ExpiredTime: data.data.expiredTime, // 时间戳，单位秒，如：1580000000
            });
          };
          xhr.send();
        },
        UseAccelerate: that.miniConfigData.upload_use_accelerate,
      });
    },
    randomString(len) {
      len = len || 32;
      const chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      const maxPos = chars.length;
      let pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    two(num) {
      if (num < 10) {
        return "0" + num;
      }
      return num;
    },
    cosUpload(uid, file) {
      return new Promise((resolve, reject) => {
        const time = new Date();
        const y = time.getFullYear();
        const m = this.two(time.getMonth() + 1);
        const d = this.two(time.getDate());
        const fileName = this.randomString() + file.name;
        const uploadPath = "/uploads/" + uid + "/" + y + "/" + m + "/" + d;
        const storeAs = uploadPath + "/" + fileName;
        this.cos.uploadFile(
          {
            Bucket: "tengface-live-user-1308721187",
            /* 填入您自己的存储桶，必须字段 */
            Region: "ap-guangzhou",
            /* 存储桶所在地域，例如ap-beijing，必须字段 */
            Key: storeAs,
            /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
            StorageClass: "STANDARD",
            Body: file, // 上传文件对象
            onTaskReady: (taskId) => {
              /* 非必须 */
              // this.form.file[0].taskId = taskId
            },
          },
          (err, data) => {
            if (data.statusCode === 200) {
              resolve(`https://${data.Location}`);
            }
            if (err) {
              // this.$set(this.enclosureForm.file[0], 'err', true)
            }
          }
        );
      });
    },
    async imgList(file) {
      this.occupyImg = await this.cosUpload(this.uid, file);
      this.shangchuant.push(this.occupyImg);
    },
    handleRemove(file, fileList) {
      console.log(file, "1----", fileList.length);
    },
    handleClick(item) {
      // eslint-disable-next-line eqeqeq
      if (item.name == "second") {
        this.appealList();
      }
    },
    tousuJy() {
      this.dialogVisiblejy = true;
    },
    storedata() {
      // 获取公司信息
      const param = "uid=" + this.uid;
      this.axios
        .post(tool.baseUrl2() + "/api/store_data", param)
        .then((res) => {
          // eslint-disable-next-line eqeqeq
          if (res.data.code == 200) {
            if (res.data.data) {
              this.business_img = res.data.data.business_img;
              this.org_name = res.data.data.org_name;
            }
          }
        });
    },
    getSubmitData() {
      // eslint-disable-next-line eqeqeq
      if (this.inputCode == "") {
        this.$message({
          message: "请输入验证码",
          type: "error",
        });
        return;
      }
      let num = this.inputCode.toUpperCase();
      if (this.identifyCode !== num) {
        this.inputCode = "";
        this.refreshCode();
        this.$message({
          message: "请输入正确验证码",
          type: "error",
        });
      } else {
        this.inputCode = "";
        this.refreshCode();
        this.$message({
          message: "验证成功",
          type: "success",
        });
        this.dialogVisiblesh = false;
        this.dialogVisiblelist = true;
      }
    },
    // 验证码
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    // 初始化验证码
    refreshCode() {
      this.identifyCode = ""; // 输入框置空
      this.makeCode(this.identifyCodeType, 4); // 验证码长度为4
    },
    // 随机切换验证码
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode +=
          this.identifyCodeType[
            this.randomNum(0, this.identifyCodeType.length)
          ];
      }
      //   console.log(this.identifyCode);
    },
    yanzhengmal() {
      this.dialogVisiblesh = true;
      this.refreshCode();
      this.storedata();
    },
    handleCurrentChange(item) {
      this.page = item;
      this.orderList();
    },
    orderList() {
      // 我的订单
      const data = {
        page: this.page,
        num: 5,
      };
      this.axios
        .post(tool.baseUrlSchool() + "/core/orderList", qs.stringify(data))
        .then((res) => {
          // eslint-disable-next-line eqeqeq
          if (res.data.code == 200) {
            this.tableData = res.data.data.list;
            this.total = res.data.data.count;
            this.dialogVisible = true;
          }
        });
    },
    woDdindan() {
      this.orderList();
    },
    tongBunc() {
      this.$emit("xianShiewmt");
    },
    getOnlineInfo() {
      // 网校地址
      const data = {};
      this.axios
        .post(tool.baseUrlSchool() + "/core/getOnlineInfo", qs.stringify(data))
        .then((res) => {
          // eslint-disable-next-line eqeqeq
          if (res.data.code == 200) {
            if (tool.isIPad()) {
              window.location.href = res.data.data.wxUrl;
            } else {
              window.location.href = res.data.data.wxUrl;
              // window.open(res.data.data.wxUrl)
            }
          }
        });
    },
    guanBi() {
      this.centerDialogVisible = false;
    },
    testNum() {
      this.centerDialogVisible = true;
    },
  },
};
</script>
<style>
.jindutiao .el-step__head.is-process {
  color: #c9cdd4 !important;
  border-color: #c9cdd4 !important;
}
</style>
<style scoped>
.woDdalistjianyi >>> .el-radio__input.is-checked .el-radio__inner {
  border-color: #1872ed;
  background: #1872ed;
}
.woDdalistjianyi >>> .el-radio__input.is-checked + .el-radio__label {
  color: #1872ed;
}
.woDdalistjianyi >>> .el-tabs__active-bar {
  background: #1872ed;
}
.woDdalistjianyi >>> .el-tabs__item.is-active {
  color: #1872ed;
}
.jindutiao >>> .el-step__head.is-finish {
  color: #1872ed;
  border-color: #1872ed;
}
.jindutiao >>> .el-step__description.is-finish {
  color: #1872ed;
}
.tousuqdan {
  width: 64px;
  height: 32px;
  background: linear-gradient(118deg, #73aaff 0%, #0053ff 100%);
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  color: #ffffff;
}
.tousuqxan {
  width: 64px;
  height: 32px;
  background: #dfe3e8;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  color: #202020;
  border: none;
}
.tousucx {
  margin-top: 20px;
  margin-left: 44px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  color: #202020;
}
.tousutsls {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  color: #202020;
  margin-left: 6px;
}
.tousutsdhz {
  display: flex;
  margin-left: 20px;
  height: 18px;
  line-height: 18px;
}
.woDdalistcxts >>> .el-dialog__body {
  padding: 0;
  height: 152px;
  background: #ffffff;
  border-radius: 12px;
}
.woDdalistcxts >>> .el-dialog__header {
  padding: 0;
}
.hide-scrollbar ::-webkit-scrollbar {
  width: 0;
  height: 0;
}

/* 针对 Chrome, Edge 和 Safari */
.hide-scrollbar {
  -ms-overflow-style: none; /* IE 和 Edge */
  scrollbar-width: none; /* Firefox */
}
.jindutiao >>> .el-step__description.is-process {
  color: #86909c;
}
.tousudahz {
  height: 534px;
  overflow: auto;
}
.tousudahz::-webkit-scrollbar {
  display: none;
}
.chakantxxq {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  color: #1872ed;
}
.suoyouts {
  margin-top: 16px;
}
.yishangmy {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  color: #202020;
  margin-left: 20px;
}
.tousulist {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  color: #666666;
}
.lishijindu {
  width: 513px;
  border-bottom: 1px #dee2e9 solid;
  margin-top: 8px;
  overflow: hidden;
  padding-bottom: 20px;
}
.quedingts {
  width: 64px;
  height: 32px;
  background: linear-gradient(118deg, #73aaff 0%, #0053ff 100%);
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
}
.quxiaots {
  width: 64px;
  height: 32px;
  background: #dfe3e8;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  text-align: center;
  color: #202020;
}
.tupianxh {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  float: left;
  margin-right: 10px;
  margin-top: 5px;
}
.tupianfa >>> .el-upload--picture-card {
  width: 80px;
  height: 80px;
  background: #f5f5f5;
  border-radius: 4px;
  line-height: 80px;
}
.tupianfa >>> .el-upload-list--picture-card {
  display: none;
}
.tupianfa {
  margin-top: 11px;
}
.tousulx {
  display: flex;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  color: #202020;
  margin-top: 20px;
}
.mianzeds {
  margin-left: 24px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  color: #202020;
}
.woDdalistjianyi >>> .el-dialog__body {
  padding: 0;
  height: 100%;
  background: #ffffff;
  border-radius: 12px;
}
.woDdalistjianyi >>> .el-dialog__header {
  padding: 0;
}
.woyizx {
  width: 164px;
  height: 36px;
  background: linear-gradient(101deg, #73aaff 0%, #0053ff 100%);
  border-radius: 22px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  line-height: 36px;
  margin: 0 auto;
  margin-top: 20px;
}
.shenmwz {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  color: #202020;
  padding: 0 24px;
  line-height: 20px;
  height: 360px;
  overflow: auto; /* 添加滚动条 */
  scrollbar-width: none;
  margin-top: 26px;
}
.mianzed p {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  color: #202020;
}
.mianzed {
  text-align: center;
  margin-top: 11px;
}
.woDdalistsan >>> .el-dialog__body {
  padding: 0;
  height: 528px;
  background: #ffffff;
  border-radius: 12px;
}
.woDdalistsan >>> .el-dialog__header {
  padding: 0;
}
.gongming {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  color: #202020;
  margin-left: 20px;
}
.qiyemc {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  color: #666666;
}
.gsxxzz {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 600;
  color: #202020;
  margin-left: 24px;
  margin-top: 2px;
}
.woDdalister >>> .el-dialog__body {
  padding: 0;
  height: 369px;
  background: #ffffff;
  border-radius: 12px;
}
.woDdalister >>> .el-dialog__header {
  padding: 0;
}
.tijiaoyz {
  width: 232px;
  height: 40px;
  line-height: 40px;
  background: linear-gradient(98deg, #73aaff 0%, #0053ff 100%);
  border-radius: 22px;
  margin: 0 auto;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  margin-top: 20px;
}
.shuruyz {
  width: 232px;
  height: 40px;
  background: #f0f0f0;
  border-radius: 22px;
  text-align: center;
  border: none;
  margin-top: 20px;
}
.kanbuqi {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  color: #202020;
  margin-top: 14px;
}
.yanzhengm {
  width: 150px;
  margin: 0 auto;
  margin-top: 21px;
}
.anquanrz {
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  color: #202020;
  margin-top: 4px;
}
.woDdalistyi input {
  outline: none;
}
.woDdalistyi >>> .el-dialog__body {
  padding: 0;
  height: 320px;
  background: #ffffff;
  border-radius: 12px;
}
.woDdalistyi >>> .el-dialog__header {
  padding: 0;
}
.woDdalistyi {
  text-align: center;
}
.fanYi {
  float: right;
  margin-right: 24px;
  margin-top: 20px;
}
.dingDan {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  color: #202020;
  margin-left: 24px;
  margin-top: 3px;
}
.woDdalist >>> .el-dialog__body {
  padding: 0;
  height: 477px;
  background: #ffffff;
  border-radius: 12px;
}
.woDdalist >>> .el-dialog__header {
  padding: 0;
}
.tupiany {
  width: 24px;
  height: 24px;
}
.gerenBox {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.souyoufd {
  width: 33.33%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
.tongbunc {
  margin-top: 10px;
}
.gerenzx {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  color: #202020;
}
.gerenzx {
  width: 292px;
  text-align: center;
}
.xiugaizlyi {
  position: absolute;
  width: 16px;
  height: 16px;
  margin-left: 60px;
  margin-top: 7px;
}
.xiugaizl {
  width: 16px;
  height: 16px;
  margin: 10px 0 0 266px;
  cursor: pointer;
}
.tankex {
  width: 292px;
  height: 280px;
  background: #ffffff;
  border-radius: 8px;
  position: absolute;
  right: 108px;
  top: 321px;
  z-index: 2000;
}
* {
  margin: 0;
  padding: 0;
}

/* 修改滚动条的样式 */
/* 滚动条整体样式 */
.woDdalist ::-webkit-scrollbar {
  width: 4px; /* 滚动条宽度 */
  height: 58px;
  padding-left: 10px;
}

/* 滚动条轨道样式 */
.woDdalist ::-webkit-scrollbar-track {
  background: #f8f7f7; /* 滚动条轨道背景色 */
}

/* 滚动条滑块样式 */
.woDdalist ::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.18); /* 滚动条滑块颜色 */
  border-radius: 6px; /* 滑块圆角 */
}

/* 鼠标悬停在滑块上的样式 */
.woDdalist ::-webkit-scrollbar-thumb:hover {
  background: #727171; /* 悬停时的颜色 */
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter.vue